import React from "react";
import { Button, Spinner, Chip } from "@heroui/react";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { MdCancel, MdWarning } from "react-icons/md";
import { RxReload } from "react-icons/rx";
import { TbReload } from "react-icons/tb";

export default function ProductStockCheckDetails({
  canCheckStock,
  discontinued,
  isStockDataLoading,
  refetch,
  error,
  productQty,
  minQty,
  stockQuatity,
  availableStock,
  hideTitle = false,
}: {
  canCheckStock: boolean;
  discontinued: boolean;
  isStockDataLoading: boolean;
  refetch: () => void;
  error: Error | null;
  productQty: number;
  stockQuatity: number;
  minQty: number;
  availableStock: boolean;
  hideTitle?: boolean;
}) {
  const shouldCheckStock = canCheckStock && !discontinued;

  return (
    <div className="flex items-center justify-between w-fit flex-wrap space-y-2 md:space-y-0 px-2 sm:px-3 md:px-4">
      {!hideTitle && (
        <span className="text-lg md:text-xl font-semibold text-primary dark:text-yellow">
          Select Product Details
        </span>
      )}

      <div className="flex flex-col gap-2">
        {shouldCheckStock && isStockDataLoading && (
          <div className="flex gap-2 items-center">
            <Chip
              size="lg"
              color="primary"
              variant="flat"
              startContent={<Spinner size="sm" className="text-white" />}
            >
              Checking Available Stock...
            </Chip>
          </div>
        )}

        {shouldCheckStock && error && !isStockDataLoading && (
          <div className="flex  items-center  gap-2">
            <span className="text-red-600">Failed to check stock.</span>
            <Button
              isIconOnly
              color="primary"
              radius="full"
              className=" text-3xl"
              onPress={refetch}
            >
              <TbReload size={18} />
            </Button>
          </div>
        )}

        {shouldCheckStock && !isStockDataLoading && !error && (
          <>
            {availableStock ? (
              stockQuatity >= minQty && productQty >= minQty ? (
                <div className="flex gap-2 items-center text-green-600">
                  <IoMdCheckmarkCircle className="text-2xl" />
                  <span>In stock</span>
                </div>
              ) : (
                <div className="flex gap-2 items-center text-yellow-600">
                  <MdWarning className="text-2xl" /> <span> Below Min Quantity</span>
                </div>
              )
            ) : (
              <div className="flex gap-2 items-center text-red-600">
                <MdCancel className="text-2xl" />
                <span>Out of stock</span>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
